// extracted by mini-css-extract-plugin
export default {"support":"styles_support__NcdSi"};